import { Navigate } from 'react-router-dom';
import { useUserProfile } from '@/hooks/useUserProfile';
import { toast } from 'sonner';
import { useEffect, useState } from 'react';

export function SuperAdminRoute({ children }: { children: React.ReactNode }) {
  const { isSuperAdmin, isLoading } = useUserProfile();
  const [hasShownToast, setHasShownToast] = useState(false);

  useEffect(() => {
    if (!isLoading && !isSuperAdmin && !hasShownToast) {
      toast.error('Acesso negado. Apenas Super Administradores podem acessar esta área.');
      setHasShownToast(true);
    }
  }, [isLoading, isSuperAdmin, hasShownToast]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isSuperAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
